'use strict';

var $ = require('jquery');

/**
 * @private
 * @function
 * @description Initializes events on checkout login page:
 */
function initializeEvents() {
    // $('.pt_cart')
    $('#guest-subtitle').on('click', function (e) {
        $(this).attr('data-content', '@icon-minus');
        // .toggleClass('minus');
    });
}

exports.init = function () {
    initializeEvents();
};
